import React from "react";

import Footer from "../Footer";
import Header from "../Header";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { Button, Container } from "react-bootstrap";

import { useSelector } from "react-redux";
import { blobURL } from "common/StringUtils";
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import LinkPhoneNumber from "../../LinkPhoneNumber";
import { LOCALES } from "common/constants";
import { getSchemaMarkup } from "common/FunctionUtils";
//

const InfoInspiration = ({ dashboardFooter }) => {
  const schemaMarkup = getSchemaMarkup("hur-mycket-ska-jag-fakturera-som-frilansare");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const billingGIF = `${blobURL}/billing.gif`;

  const user = useSelector((state) => state.auth.user);
  const invoiceInspiration = `${blobURL}/Inspirtation.jpg`;
  const inspirationNew = `${blobURL}/inspirtation_new.png`;
  let language = localStorage.getItem("i18nextLng");
  const feesGIF = `${blobURL}/fees.gif`;
  const industryFee = `${blobURL}/industry-fee.gif`;
  const negotiateImg = `${blobURL}/negotiate.png`;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="network-page">
      <Helmet>
        {schemaMarkup && (
          <script type="application/ld+json">
            {JSON.stringify(schemaMarkup)}
          </script>
        )}
        <title>
          {t("How much can you invoice as a freelancer or consultant?")}
        </title>
        <meta
          name="description"
          content={t(
            "How much can you invoice as a freelancer? Get a handle on salary, fees, and taxes. Calculate your rate and optimize your income as a self-employed professional, and start invoicing!"
          )}
        />
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/how-much-should-I-invoice-as-a-freelancer"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/hur-mycket-ska-jag-fakturera-som-frilansare"
          />
        )}
      </Helmet>
      <Header />
      <Container className="p-0">
        <div className="inspiration fakt new_desgn_insurance new_margin_header mt-5 p-0">
          <section className="insurns_wrap info_wrap negotiation info-inspiration">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-6 col-sm-12">
                  <div className="security_fntw">
                    <h1 className="security_about text-uppercase mb-0">
                      {t("How much can you invoice as a freelancer")}
                    </h1>

                    <p className="collct_info fnt_family">
                      {t(
                        "Here we collect information relating to your assignments and your work situation"
                      )}
                    </p>
                    {!user && (
                      <Button
                        variant=""
                        className="mt-3 new_theme_btn "
                        onClick={() =>
                          navigate(
                            language === LOCALES.EN_US
                              ? `/emailregister?lang=${LOCALES.EN_US}`
                              : `/e-postregister?lang=${LOCALES.SV_SE}`
                          )
                        }
                      >
                        {t("Create Free Account")}
                      </Button>
                    )}
                  </div>
                </div>
                <div className="col-md-6 col-sm-12">
                  <div className="text-right imge_text">
                    <div className="image_wrap new_wrap">
                      <img
                        src={invoiceInspiration}
                        alt="inspiration-banner"
                        className="image-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="payment_session">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <div className="text_wrap">
                    <div className="info_wrap newdesign">
                      <h2 className="heading_edit">
                        {t("How much can you invoice as a freelancer")}
                      </h2>
                      <p>
                        {/* {t(
                          "When you are self-employed, Invozio is your employer. We try to make your time with us as inspiring and developing as possible."
                        )} */}
                        {t("When you are")}
                        <Link
                          style={{
                            fontWeight: "600",
                            textDecoration: "underline",
                          }}
                          to={
                            language === LOCALES.EN_US
                              ? `/self-employment?lang=${LOCALES.EN_US}`
                              : `/egenanstallning?lang=${LOCALES.SV_SE}`
                          }
                        >
                          {" "}
                          <u>{t("self-employed")}</u>
                        </Link>{" "}
                        {t(
                          "Invozio is your employer. We try to make your time with us as inspiring and developing as possible."
                        )}
                      </p>
                      <p>
                        {t(
                          "With long experience and broad competence, we are here to support your self-employed in the best way so we can get through the current situation together."
                        )}
                      </p>
                      <p>
                        {t(
                          "Here we collect information relating to your assignments and your work situation. We also collect various inspiring initiatives to give you tips, encouragement and opportunities."
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="inspitn_new">
                    <img
                      src={inspirationNew}
                      className="img-fluid"
                      alt="info-inspiration"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="freelancer-consultant">
            <div className="container">
              <div className="invoice">
                <h1 className="heading_edit">
                  {t("How much can you invoice as a freelancer or consultant?")}
                </h1>
                <p className="m-0">
                  {t(
                    "Being a freelancer or consultant gives you the freedom to determine and"
                  )}{" "}
                  <Link
                    to={language === LOCALES.EN_US ? `/?lang=${LOCALES.EN_US}` : `/?lang=${LOCALES.SV_SE}`}
                    style={{
                      fontWeight: "600",
                      textDecoration: "underline",
                    }}
                  >
                    <u>{t("invoice without a company.")}</u>
                  </Link>{" "}
                  {t(
                    "There is no fixed salary scale governing how much you can charge for your services. Instead, it's up to you to decide the value of your work. This is not always easy to determine and is influenced by the number of people possessing your skills (number of competitors) and the perceived value you bring to your clients."
                  )}
                </p>
              </div>
            </div>
          </section>
          <section className="freelancer-consultant second">
            <div className="container">
              <div className="invoice">
                <h2 className="heading_edit second_heading">
                  {t("Understanding freelance and consultant fees")}
                </h2>
                <p className="m-0">
                  {t("Being a")} {" "}
                  <Link
                    style={{
                      fontWeight: "600",
                      textDecoration: "underline",
                    }}
                    to={
                      language === LOCALES.EN_US
                        ? `/working-as-a-freelancer-and-invoicing-without-tax-registration?lang=${LOCALES.EN_US}`
                        : `/att-jobba-som-frilansare-och-fakturera-utan-fskatt?lang=${LOCALES.SV_SE}`
                    }
                  >
                    <u>{t("freelancer")}</u>
                  </Link>{" "}
                  {t(
                    "or consultant means offering your professional services to various clients. It can be an exciting and flexible way to work, but it's important to understand the differences between freelance and consultant fees."
                  )}
                </p>

                <div className="row align-items-center mt-4">
                  <div className="col-md-12">
                    <img
                      src={feesGIF}
                      alt="logo"
                      className="imganimate"
                      loading="lazy"
                    />
                    <div>
                      <h3 className="heading_edit second_heading">
                        {t(
                          "Differences in invoicing between freelance and consultant fees"
                        )}
                      </h3>
                      <p>
                        {t(
                          "As a freelancer, you are typically an individual offering your services to various clients. You may specialize in a specific area or provide a broader expertise. Your fees can vary depending on the scope of the project, your experience, and market conditions."
                        )}
                      </p>
                      <p className="m-0">
                        {t(
                          "On the other hand, consultant fees can be higher than freelance fees. As a consultant, you are expected to have a deeper knowledge and experience in your field. You may also work with consulting firms that broker your services to clients."
                        )}
                      </p>

                      <h3 className="heading_edit second_heading">
                        {t("Factors influencing your fee")}
                      </h3>
                      <p>
                        {t(
                          "When determining your fee as a freelancer or consultant, there are several factors to consider. Your own experience and expertise play a crucial role. The more experienced and knowledgeable you are in your field, the higher you can charge for your services. The complexity of a freelance or consulting assignment is another factor. If a project requires extra effort or specialized knowledge, it may be reasonable to charge a higher fee. Additionally, time and resources come into play. The amount of time and resources you need to invest in a project can impact your fee. Remember to take into account your own costs and profit margins."
                        )}
                      </p>
                      <p className="m-0">
                        {t(
                          "It is also important to be aware of market conditions and competition within your field. Having clear and competitive pricing can help you attract potential clients and secure profitable projects. A tip for eventually being able to charge more is to start initially with a lower fee until you have a portfolio to showcase and can, therefore, invoice with confidence."
                        )}
                      </p>
                      <p className="m-0">
                        {t(
                          "It's also important to consider the client's budget and payment terms. Try to understand what the client is willing to pay and find out when they can make payments. This can help avoid financial misunderstandings and strengthen the relationship with the client. Adjust your rate based on the type of client. Large companies often have larger budgets, while smaller businesses or individual entrepreneurs may be sensitive to high prices. Flexibility and understanding of the client's financial situation can lead to longer and more rewarding collaborations."
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* <section className="freelancer-consultant third">
            <div className="container">
                <div className="invoice">
                 
                </div>
            </div>
          </section>
          <section className="freelancer-consultant fourth">
            <div className="container">
                <div className="invoice">
                  
                </div>
              </div>
          </section> */}
          <section className="freelancer-consultant fifth">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <div className="invoice">
                    <h2 className="heading_edit second_heading">
                      {t("Setting your fee as a freelancer")}
                    </h2>
                    <p>
                      {t(
                        "As a freelancer, it is important to determine your value based on your experience and skills. Here are a few steps to follow:"
                      )}
                    </p>
                    <h3 className="heading_edit">
                      {t("Determining your value")}
                    </h3>
                    <p className="mt-0">
                      {t(
                        "First and foremost, you should research the market to get an idea of what other freelancers in your area are charging. You can also reach out to industry organizations or networks to gather valuable information on average fees. Having knowledge of market rates can help you set a competitive fee that is reasonable for both you and your clients. It can also give you an idea of how to differentiate yourself and provide added value to justify a higher fee."
                      )}
                    </p>

                    <h3 className="heading_edit">
                      {t("Evaluate your skills as a freelancer")}
                    </h3>
                    <p className="mt-0">
                      {t(
                        "The next step is to evaluate your own experience and expertise. If you have extensive experience or specialized knowledge, you may be able to charge a higher fee than someone who is new to the industry. It's important to be realistic when assessing your own skills. Overestimating yourself can lead to losing potential clients, while underestimating yourself may mean not getting paid what you deserve."
                      )}
                    </p>

                    <h3 className="heading_edit">
                      {t("Taking market conditions into account")}
                    </h3>
                    <p className="mt-0">
                      {t(
                        "It's important to be aware of market conditions when setting your fee. If there is high demand and a shortage of qualified freelancers, you may have the opportunity to charge a higher fee. On the other hand, a competitive market may require you to lower your prices to attract clients."
                      )}
                    </p>

                    <h3 className="heading_edit">
                      {t("The industry's economic situation")}
                    </h3>
                    <p className="mt-0">
                      {t(
                        "Another factor to consider is the economic situation in your industry or the country where you work. During a downturn, it may be more challenging to acquire clients, and you might need to adjust your fee to remain competitive. It's also worthwhile to investigate whether there are any industry trends or technological changes that could affect the demand for your services. Being aware of these factors can help you tailor your fee and business strategy to meet the market's needs."
                      )}
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="invoice">
                    <h2 className="heading_edit second_heading">
                      {t("Setting your fee as a consultant")}
                    </h2>
                    <p className="mt-0">
                      {t(
                        "As a consultant, you are expected to have a higher level of expertise and experience. Your expertise and experience play a significant role in determining how much you can charge as a consultant. If you have specialized in a specific area or have extensive experience in your field, your fee may be higher. It's important to remember that your expertise and experience are not just about the number of years you have worked in your industry; it also encompasses the results you have achieved and the challenges you have overcome. Being able to showcase concrete examples of successful projects and satisfied clients can enhance your value as a consultant and thus impact your fee."
                      )}
                    </p>

                    <h3 className="heading_edit">
                      {t("Continual skills development for higher invoicing")}
                    </h3>
                    <p className="mt-0">
                      {t(
                        "Continuously updating your knowledge and staying informed about the latest trends and developments in your field can also be advantageous. This demonstrates your commitment to being an expert in your field and can positively impact your fee."
                      )}
                    </p>

                    <h3 className="heading_edit">
                      {t("Considering your industry and specialization")}
                    </h3>
                    <p className="mt-0">
                      {t(
                        "Fees can vary depending on the industry and specialization. Some industries have high demand for consultants and may, therefore, offer higher fees. It's important to research the market and find out what consultants in your industry charge. In addition to the industry, your specialization can also impact your fee. If you have a unique specialty or area of expertise that is in demand, you may have the opportunity to charge higher fees. It's worth exploring which specialties are most sought after and adapting your offerings to meet market needs. Having knowledge of your industry and specialization can also help you position yourself as an expert and differentiate yourself from competitors. By showcasing your unique knowledge and experience, you can increase your value as a consultant and thus positively impact your fee."
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="freelancer-consultant seventh">
            <div className="container">
              <div className="invoice">
                <h2 className="heading_edit">
                  {t("Fees to invoice in different industries")}
                </h2>
                <p className="p-0">
                  {t(
                    "Fees can vary significantly between different industries. It depends on several factors, including demand, specialization, and experience. Here are some examples of fees in different industries."
                  )}
                </p>

                <div className="row align-items-center">
                  <div className="col-md-12 p-0">
                    <img
                      src={industryFee}
                      alt="logo"
                      className="imganimateright"
                      loading="lazy"
                    />
                    <h3 className="heading_edit">
                      {t("Fees in technology and IT")}
                    </h3>
                    <p className="mt-0">
                      {t(
                        "In the technology and IT industry, fees can be relatively high. The demand for specialized technical consultants and freelancers is often high, allowing you to charge a higher fee. Additionally, the technology and IT field is constantly evolving, creating a consistent demand for new knowledge and expertise. This can also positively impact fees. For instance, an experienced software developer or data engineer can expect to earn a higher fee than someone who is new to the industry. There is also the opportunity to negotiate fees depending on the scope and complexity of the project."
                      )}
                    </p>

                    <h3 className="heading_edit">
                      {t("Fees in marketing and communication")}
                    </h3>
                    <p className="mt-0">
                      {t(
                        "In marketing and communication, fees can vary depending on the type of service and experience. Fees for strategic consulting and market research may be higher than for operational tasks such as social media management. It's important to note that marketing and communication are areas where creativity and strategic thinking play a significant role. Therefore, individuals with strong analytical and creative skills can expect to earn a higher fee. Experience and previous successful campaigns can also positively impact the fee."
                      )}
                    </p>

                    <h3 className="heading_edit">
                      {t("Fees in design and creative professions")}
                    </h3>
                    <p className="mt-0">
                      {t(
                        "Design and creative professions can also be lucrative. Depending on your experience and portfolio, you can charge higher fees for your creative services such as graphic design or web development. In the design industry, it's common for fees to be based on the scope and complexity of the project. The more complex and time-consuming the design task, the higher the fee may be. Designers often charge an hourly rate for smaller tasks or consultations. It's important to remember that design and creative professions often require a combination of technical skills and creative thinking. Therefore, individuals with a strong portfolio and a unique design aesthetic can expect to earn a higher fee."
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="freelancer-consultant eigth">
            <div className="container">
              <div className="invoice">
                <h2 className="heading_edit">
                  {t(
                    "Average hourly billing for freelancers and consultants in various industries"
                  )}
                </h2>
                <p className="mt-0">
                  {t(
                    "Hourly billing is a crucial factor for freelancers and consultants in various industries. By understanding and setting the right hourly rate, one can optimize income and establish a sound financial foundation for their business. But what is the average hourly billing rate in different industries and professions? Hourly billing can vary significantly depending on the industry. Here, we take a closer look at some common industries and their average hourly billing rates"
                  )}
                </p>

                <div className="row align-items-center">
                  <div className="col-md-12">
                    <img
                      src={billingGIF}
                      alt="logo"
                      className="imganimate"
                      loading="lazy"
                    />
                    <div>
                      <h3 className="heading_edit">
                        {t("Hourly billing within the IT industry")}
                      </h3>
                      <p className="mt-0">
                        {t(
                          "Within the IT industry, hourly billing is typically relatively high. This is due to the specialized knowledge and technical expertise required. The average hourly billing rate in the IT industry can vary between 500-1500 Swedish Kronor per hour, depending on experience, skills, and the type of project. The IT industry is a dynamic and rapidly growing sector. With the constant evolution of technology and digitization, the demand for IT experts is increasing. There are various areas within the IT industry, such as software development, network engineering, database management, and cloud services. Each area requires specific knowledge and skills, influencing the hourly billing rate."
                        )}
                      </p>

                      <h3 className="heading_edit">
                        {t("Hourly billing within creative professions")}
                      </h3>
                      <p className="mt-0">
                        {t(
                          "Creative professions such as graphic design, web development, and copywriting often command higher hourly billing rates due to the creative and unique expertise they require. The average hourly billing rate within creative professions can range from 400-1000 Swedish Kronor per hour, depending on experience, portfolio, and the complexity of the project. In creative professions, the ability to offer innovative and aesthetically appealing solutions is crucial. Graphic designers create visually attractive marketing materials, while web developers build user-friendly and responsive websites. Copywriters craft engaging and persuasive texts for various purposes."
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="freelancer-consultant ninth">
            <div className="container">
              <div className="invoice-group">
                <h2 className="heading_edit">
                  {t(
                    "List of 10 additional popular freelance jobs and what you can charge per hour"
                  )}
                </h2>
                <p className="mt-0 mb-5">
                  {t(
                    "Here is a list of ten popular freelance industries along with an estimate of what one can invoice per hour for each industry. Please note that these figures can vary depending on factors such as experience, location, demand, and individual skill."
                  )}
                </p>

                <div className="row">
                  <div className="col-md-6">
                    <div className="invoice">
                      <div className="invoice-content">
                        <h3 className="heading_edit">
                          {t("Invoice for Web Development and Programming")}
                        </h3>
                        <p className="mb-0">
                          {t("Average hourly rate: 500 - 1,000 SEK.")}
                        </p>
                        <p className="mt-0">
                          {t(
                            "Includes: Web design, frontend and backend development, mobile app development."
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="invoice">
                      <div className="invoice-content">
                        <h3 className="heading_edit">
                          {t("Invoice for Graphic Design")}
                        </h3>
                        <p className="mb-0">
                          {t("Average hourly rate: 300 - 800 SEK")}
                        </p>
                        <p className="mt-0">
                          {t(
                            "Includes: Logo design, brochures, posters, user interfaces."
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="invoice">
                      <div className="invoice-content">
                        <h3 className="heading_edit">
                          {t("Invoice for Digital Marketing")}
                        </h3>
                        <p className="mb-0">
                          {t("Average hourly rate: 400 - 2000 SEK")}
                        </p>
                        <p className="mt-0">
                          {t(
                            "Includes: SEO, social media, email marketing, content strategy, Google Ads, PPC advertising"
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="invoice">
                      <div className="invoice-content">
                        <h3 className="heading_edit">
                          {t("Invoice for Writer and Copywriting")}
                        </h3>
                        <p className="mb-0">
                          {t("Average hourly rate: 250 - 700 SEK")}
                        </p>
                        <p className="mt-0">
                          {t(
                            "Includes: Blog posts, articles, product descriptions, copywriting."
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="invoice">
                      <div className="invoice-content">
                        <h3 className="heading_edit">
                          {t(
                            "Invoice for Translation and Interpretation Services"
                          )}
                        </h3>
                        <p className="mb-0">
                          {t("Average hourly rate: 300 - 800 SEK")}
                        </p>
                        <p className="mt-0">
                          {t(
                            "Includes: Document translation, simultaneous interpretation, subtitling."
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="invoice">
                      <div className="invoice-content">
                        <h3 className="heading_edit">
                          {t("Invoice for IT Consulting and Network Security")}
                        </h3>
                        <p className="mb-0">
                          {t("Average hourly rate: 600 - 1 200 SEK")}
                        </p>
                        <p className="mt-0">
                          {t(
                            "Includes: IT support, network administration, cybersecurity."
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="invoice">
                      <div className="invoice-content">
                        <h3 className="heading_edit">
                          {t("Invoice for Photography and Videography")}
                        </h3>
                        <p className="mb-0">
                          {t("Average hourly rate: 400 - 1 000 SEK")}
                        </p>
                        <p className="mt-0">
                          {t(
                            "Includes: Event photography, product photography, video editing."
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="invoice">
                      <div className="invoice-content">
                        <h3 className="heading_edit">
                          {t("Invoice for Accounting and Financial Advisory")}
                        </h3>
                        <p className="mb-0">
                          {t("Average hourly rate: 500 - 1 000 SEK")}
                        </p>
                        <p className="mt-0">
                          {t(
                            "Includes: Accounting, tax advisory, financial planning."
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="invoice">
                      <div className="invoice-content">
                        <h3 className="heading_edit">
                          {t("Invoice for Architecture and Interior Design")}
                        </h3>
                        <p className="mb-0">
                          {t("Average hourly rate: 500 - 1 200 SEK")}
                        </p>
                        <p className="mt-0">
                          {t(
                            "Includes: Drawings, interior design, landscape design."
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="invoice">
                      <div className="invoice-content">
                        <h3 className="heading_edit">
                          {t("Invoice for Legal Advice")}
                        </h3>
                        <p className="mb-0">
                          {t("Average hourly rate: 800 - 2 000 SEK")}
                        </p>
                        <p className="mt-0">
                          {t(
                            "Includes: Contract law, intellectual property law, business law. These figures are approximate and may vary depending on the specific market and the individual's experience and expertise."
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <h3 className="heading_edit">
                  {t("Hourly billing in the consulting industry")}
                </h3>
                <p>
                  {t(
                    "In the consulting industry, hourly billing varies depending on the consultant's expertise and experience. The average hourly billing rate for consultants can range between 800-2000 Swedish kronor, depending on the industry, demand, and type of consulting service."
                  )}
                </p>
              </div>
            </div>
          </section>

          <section className="freelancer-consultant tenth">
            <div className="container">
              <div className="invoice">
                <div className="row">
                  <h2 className="heading_edit">
                    {t("Common questions about freelance and consulting fees")}
                  </h2>
                  <p>
                    {t(
                      "To be a freelancer or consultant involves managing various aspects of your work, including establishing and negotiating your fee. Here are some common questions and tips to help you navigate through this area."
                    )}
                  </p>
                  <div className="col-md-12">
                    <img
                      src={negotiateImg}
                      alt="logo"
                      className="imganimateright"
                    />
                    <div className="invoice-content">
                      <h3 className="heading_edit">
                        {t("How often should I review and adjust my fee?")}
                      </h3>
                      <p className="mt-0">
                        {t(
                          "It is important to regularly review and adjust your fee to stay competitive and ensure you are compensated for your expertise and time. Establish a routine and go through your fees at least once a year or when market conditions change. By staying updated on the latest trends and prices in your industry, you can ensure that your fee is reasonable and fair. Be aware of your own level of experience and expertise, as well as how demand for your services may impact your fee. For example, in emerging fields like AI, specialists may charge double or triple the rate of a regular developer."
                        )}
                      </p>

                      <h3 className="heading_edit">
                        {t("How do I handle negotiations about fees?")}
                      </h3>
                      <p className="mt-0">
                        {t(
                          "Negotiating fees is a common part of being a freelancer or consultant. Being able to negotiate successfully is crucial to achieve a fee that reflects your expertise and value. You can turn to us at Invozio as we have experienced specialists in negotiation."
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="freelancer-consultant eleventh">
            <div className="container">
              <div className="invoice">
                <div className="invoice-content">
                  <Button
                    className="mt-4 mb-2 create-account filled home_create_account"
                    onClick={() => {
                      navigate(
                        language === LOCALES.EN_US
                          ? `/emailregister?lang=${LOCALES.EN_US}`
                          : `/e-postregister?lang=${LOCALES.SV_SE}`
                      );
                      sessionStorage.setItem("accountType", 1);
                    }}
                  >
                    {t(
                      "Sign up and start invoicing at the market's best prices"
                    )}
                  </Button>
                  <p className="mt-0">
                    {t("For more information, email us at")}
                    <a href="mailto:support@invozio.com" className="email">
                      support@invozio.com
                    </a>
                    {t("or call us at")}
                    <LinkPhoneNumber />
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </Container>
      <Footer dashboardFooter={dashboardFooter} />
    </div>
  );
};

export default InfoInspiration;
